import styled from '@emotion/styled'
import { CSSProperties } from 'react'

type SectionProps = {
  title: string
  children: React.ReactNode
  gap?: CSSProperties['gap']
  titleGap?: CSSProperties['gap']
}

const SectionTitle = styled.h2`
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`

const SectionContainer = styled.div<{
  gap?: CSSProperties['gap']
  titleGap?: CSSProperties['gap']
}>(({ gap, titleGap }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: titleGap || gap,
}))

const ChildrenContainer = styled.div<{ gap?: CSSProperties['gap'] }>(({ gap }) => ({
  display: 'flex',
  flexDirection: 'column',
  lineHeight: 1.5,
  gap,
}))

export const Section = ({ title, children, gap = '8px', titleGap = '8px' }: SectionProps) => {
  return (
    <SectionContainer gap={gap} titleGap={titleGap}>
      <SectionTitle>{title}</SectionTitle>
      <ChildrenContainer gap={gap}>{children}</ChildrenContainer>
    </SectionContainer>
  )
}
